<div class="dtrp-field" cdkOverlayOrigin #origin="cdkOverlayOrigin" [class.has-icon]="showIcon">
  <input
    class="form-field-input dtrp-input"
    [value]="displayValue"
    [placeholder]="placeholder"
    [disabled]="disabled"
    readonly
    (click)="toggle()"
    />
  @if (showClearButton && (start || end) && !disabled) {
    <button
      type="button"
      class="dtrp-clear"
      aria-label="Clear date range"
      (click)="$event.stopPropagation(); clear()"
      >
      <mat-icon>close</mat-icon>
    </button>
  }
  @if (showIcon) {
    <button
      type="button"
      class="dtrp-button"
      [disabled]="disabled"
      (click)="toggle()"
      [attr.aria-label]="ariaLabel"
      >
      <mat-icon>calendar_today</mat-icon>
    </button>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayFlexibleDimensions]="false"
  [cdkConnectedOverlayPush]="true"
  (backdropClick)="close()"
  >
  <div class="dtrp-overlay" [style.--dtrp-panel-width]="panelWidth" (keydown.escape)="$event.stopPropagation(); close()">
    <mat-calendar
      [selected]="activePart === 'start' ? start : end"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [dateClass]="dateClass"
      [headerComponent]="headerComponent"
      (selectedChange)="onDateSelected($event)"
    ></mat-calendar>

    <div class="dtrp-time">
      <div class="dtrp-time-single" [attr.data-active]="activePart">
        <div class="dtrp-time-row">
          <div class="dtrp-time-col">
            <button type="button" class="dtrp-time-btn" (click)="adjustHour(1)" aria-label="Increase hour">
              <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
            <div class="dtrp-time-value">{{ twoDigit(activeHourDisplay) }}</div>
            <button type="button" class="dtrp-time-btn" (click)="adjustHour(-1)" aria-label="Decrease hour">
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </div>
          <div class="dtrp-time-sep">:</div>
          <div class="dtrp-time-col">
            <button type="button" class="dtrp-time-btn" (click)="adjustMinute(1)" aria-label="Increase minute">
              <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
            <div class="dtrp-time-value">{{ twoDigit(activeMinute) }}</div>
            <button type="button" class="dtrp-time-btn" (click)="adjustMinute(-1)" aria-label="Decrease minute">
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </div>
          @if (hourFormat === 12) {
            <div class="dtrp-time-col">
              <button type="button" class="dtrp-time-btn" (click)="toggleMeridian()" aria-label="Toggle AM/PM">
                <mat-icon>keyboard_arrow_up</mat-icon>
              </button>
              <div class="dtrp-time-value dtrp-meridian">{{ activeMeridian }}</div>
              <button type="button" class="dtrp-time-btn" (click)="toggleMeridian()" aria-label="Toggle AM/PM">
                <mat-icon>keyboard_arrow_down</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    @if (showButtonBar) {
      <div class="dtrp-actions">
        @if (showTodayButton) {
          <button type="button" class="dtrp-action" (click)="setToday()" [disabled]="disabled">
            {{ todayLabel }}
          </button>
        }
        @if (showClearButton) {
          <button type="button" class="dtrp-action" (click)="clear()" [disabled]="disabled">
            {{ clearLabel }}
          </button>
        }
        @if (showCloseButton) {
          <button type="button" class="dtrp-action primary" (click)="close()" [disabled]="disabled">
            {{ closeLabel }}
          </button>
        }
      </div>
    }

    <!-- Optional projected footer actions (e.g. Graph / Close) -->
    <div class="dtrp-footer">
      <ng-content select="[dtrpFooter]"></ng-content>
    </div>
  </div>
</ng-template>

